import { CSSProperties } from 'react';

interface Props {
  viewBoxProp?: string;
  styleProp?: CSSProperties;
  color: string;
}

const NoseIcon = ({ viewBoxProp, styleProp, color }: Props) => {
  const viewBox = viewBoxProp ?? "0 0 35 35";
  const style = styleProp ?? { width: '100%', height: 'auto' };

  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox={viewBox} style={style}>
      <g>
        <path d="M25.79,33H11.02c-4.41,0-8-3.59-8-8s3.59-8,8-8h2.9c1.1,0,2,0.9,2,2s-0.9,2-2,2h-2.9c-2.21,0-4,1.79-4,4
          s1.79,4,4,4h14.77c0.59,0,0.9-0.39,1-0.56s0.31-0.62,0.04-1.15L15.22,4.92c-0.51-0.98-0.13-2.19,0.85-2.7
          c0.98-0.51,2.19-0.13,2.7,0.85l11.6,22.37c0.84,1.62,0.77,3.51-0.17,5.06C29.26,32.07,27.61,33,25.79,33z"
          fill={color} />
      </g>
    </svg>
  );
}

export default NoseIcon;
